import { get, orderBy } from "lodash";
import { createSelector } from "reselect";
import { getPageContent } from "../../shared/selectors";

export const getFileImports = createSelector([getPageContent], pageContent => {
  return orderBy(get(pageContent, "file_imports", []), "id", "desc");
});

export default getFileImports;
